import axios from 'axios';
import { ServiceDefinition } from './service-definition.service';
import { API_CONFIG } from '../config/api.config';

// Definir la interfaz para la subcategoría
export interface Subcategory {
  id: string;
  name: string;
  description: string;
  iconUrl: string;
  imageUrl: string;
  isActive: boolean;
  leadPriceSubcategory: number;
  categoryId: string;
  categoryName: string;
  created: string;
  createdBy: string;
  lastModified: string;
  lastModifiedBy: string;
  serviceDefinitions: ServiceDefinition[];
}

// Servicio para manejar las operaciones relacionadas con subcategorías
export const SubcategoryService = {
  // Obtener todas las subcategorías
  getAllSubcategories: async (): Promise<Subcategory[]> => {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}api/subcategories/with-details`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default SubcategoryService;
